import { render, staticRenderFns } from "./ImageWithDesc.vue?vue&type=template&id=6306cc97&scoped=true&"
import script from "./ImageWithDesc.vue?vue&type=script&lang=js&"
export * from "./ImageWithDesc.vue?vue&type=script&lang=js&"
import style0 from "./ImageWithDesc.vue?vue&type=style&index=0&id=6306cc97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6306cc97",
  null
  
)

export default component.exports